import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueApexCharts from 'vue3-apexcharts'

// Test mode configuration
// Set this to true to bypass authentication (for testing)
// Set to false in production to require real authentication
window.isTestMode = true;

// Add a global auth check method
const isAuthenticated = () => {
  // In test mode, always return true
  if (window.isTestMode) {
    return true;
  }
  return localStorage.getItem('auth_token') !== null;
}

// Add a simulated login method for development
window.simulateLogin = () => {
  localStorage.setItem('auth_token', 'demo_token');
  router.push('/dashboard');
}

// Add a logout method
window.logout = () => {
  localStorage.removeItem('auth_token');
  router.push('/login');
}

// For demonstration - check if auth is needed
const authRequired = window.location.hash.includes('#/dashboard') || 
                     window.location.hash.includes('#/markets') ||
                     window.location.hash.includes('#/trade') ||
                     window.location.hash.includes('#/wallet') ||
                     window.location.hash.includes('#/settings');

// In test mode, automatically set a token
if (window.isTestMode && !localStorage.getItem('auth_token')) {
  localStorage.setItem('auth_token', 'test_token');
}
// Redirect to login if protected route is accessed without auth and not in test mode
else if (authRequired && !isAuthenticated() && !window.isTestMode) {
  window.location.hash = '#/login';
}

const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueApexCharts);
app.mount('#app');
